import * as React from "react";
import IframeResizer from "iframe-resizer-react";

export function IFrameTestimonials() {
  const [url, urlSet] = React.useState("https://embed.testimonial.to/w/taplio");
  React.useEffect(() => {
    urlSet("https://embed.testimonial.to/w/taplio?theme=light&card=base");
  }, []);

  return (
    <IframeResizer
      {...{
        src: url,
        style: {
          width: "1px",
          minWidth: "100%",
        },
      }}
    />
  );
}
